import React from "react";
import { Box, Typography, Container, Zoom } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { keyframes } from "@emotion/react";

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const ServiceUnavailable = () => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        height: "100%", // fill parent height
        display: "flex",
        flexDirection: "column",
        justifyContent: "center", // vertical centering
        alignItems: "center", // horizontal centering
        textAlign: "center",
        background: "linear-gradient(to right, #fdfbfb, #ebedee)",
        animation: `${fadeIn} 1s ease-in`,
      }}
    >
      <Box
        sx={{
          animation: `${pulse} 1.5s infinite`,
          color: "#ff9800",
          mb: 3,
        }}
      >
        <WarningAmberIcon sx={{ fontSize: 70 }} />
      </Box>

      <Zoom in timeout={500}>
        <Typography variant="h4" component="h1" gutterBottom>
          503 - Service Unavailable
        </Typography>
      </Zoom>

      <Zoom in timeout={1000}>
        <Typography variant="body1" maxWidth={400}>
          The server is currently unreachable. Please try again later.
        </Typography>
      </Zoom>
    </Container>
  );
};

export default ServiceUnavailable;
